import React, { useRef, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar';
import ScrollToTop from './helper/ScrollToTop';
import { GlobalStyle } from "./components/common/styles/global.js";
import HomeTwo from './HomeTwo';
import About from './pages/about/About';
import CourseGrid from './pages/history/CourseGrid';
import CourseList from './pages/history/CourseList';
import Instructor from './pages/message-from/Instructors.js';
import MessageFromChairman from './pages/message-from/MessageFromChairman.js';
import Gallery from './pages/gallery/Gallery';
import Events from './pages/AdmissionRequirements/Events.js';
import AdmissionRequirements from './pages/AdmissionRequirements/AdmissionRequirements.js';
import Login from './pages/account/Login';
import Register from './pages/account/Register';
import Contact from './pages/contact/Contact';
import Faq from './pages/faq/Faq';
import PageNotFound from './pages/404/PageNotFound';
import ComingSoon from './pages/comingsoon/ComingSoon';
import BlogClassic from './pages/mission/BlogClassic';
import BlogGrid from './pages/mission/BlogGrid';
import MissionVision from './pages/mission/mission-vision';
import Product from './pages/shop/Products';
import ProductDetails from './pages/shop/ProductDetails';
import Cart from './pages/shop/Cart';
import AdmProcess from './pages/admission/admissionProcess.js';
import { Logout } from './pages/Logout.js';
import HistoryPage from './pages/history/our-history.js';
import AdmissionProcess from './pages/AdmissionRequirements/AdmissionProcess.js';

function App() {
    const loadingBarRef = useRef(null);
    const location = useLocation();

    useEffect(() => {
        loadingBarRef.current.continuousStart();

        // Simulate async operation delay (e.g., fetching page data)
        setTimeout(() => {
            loadingBarRef.current.complete();
        }, 800); // Adjust the delay as needed
    }, [location]);

    return (
        <>
            <LoadingBar
                color='#f11946'
                ref={loadingBarRef}
                height={2}
            />
            <GlobalStyle />
            <ScrollToTop />
            <Routes>
                <Route path={`${process.env.PUBLIC_URL + "/"}`} element={<HomeTwo />} />
                <Route path={`${process.env.PUBLIC_URL + "/about"}`} element={<About />} />
                <Route path={`${process.env.PUBLIC_URL + "/course-grid"}`} element={<CourseGrid />} />
                <Route path={`${process.env.PUBLIC_URL + "/course-list"}`} element={<CourseList />} />
                <Route path={`${process.env.PUBLIC_URL + "/our-history"}`} element={<HistoryPage />} />
                <Route path={`${process.env.PUBLIC_URL + "/message-from/:role"}`} element={<MessageFromChairman />} />
                <Route path={`${process.env.PUBLIC_URL + "/gallery"}`} element={<Gallery />} />
                <Route path={`${process.env.PUBLIC_URL + "/events"}`} element={<Events />} />
                <Route path={`${process.env.PUBLIC_URL + "/admission-requirements"}`} element={<AdmissionRequirements />} />
                <Route path={`${process.env.PUBLIC_URL + "/admission-process"}`} element={<AdmissionProcess />} />
                <Route path={`${process.env.PUBLIC_URL + "/login"}`} element={<Login />} />
                <Route path={`${process.env.PUBLIC_URL + "/registration"}`} element={<Register />} />
                <Route path={`${process.env.PUBLIC_URL + "/contact"}`} element={<Contact />} />
                <Route path={`${process.env.PUBLIC_URL + "/faq"}`} element={<Faq />} />
                <Route path={`${process.env.PUBLIC_URL + "/404"}`} element={<PageNotFound />} />
                <Route path={`${process.env.PUBLIC_URL + "/coming-soon"}`} element={<ComingSoon />} />
                <Route path={`${process.env.PUBLIC_URL + "/blog-classic"}`} element={<BlogClassic />} />
                <Route path={`${process.env.PUBLIC_URL + "/blog-grid"}`} element={<BlogGrid />} />
                <Route path={`${process.env.PUBLIC_URL + "/mission-vision"}`} element={<MissionVision />} />
                <Route path={`${process.env.PUBLIC_URL + "/products"}`} element={<Product />} />
                <Route path={`${process.env.PUBLIC_URL + "/product-details"}`} element={<ProductDetails />} />
                <Route path={`${process.env.PUBLIC_URL + "/cart"}`} element={<Cart />} />
                <Route path={`${process.env.PUBLIC_URL + "/admission-process"}`} element={<AdmProcess/>} />
                <Route path={`${process.env.PUBLIC_URL + "/logout"}`} element={<Logout/>} />
                <Route path={`${process.env.PUBLIC_URL + "/*"}`} element={<PageNotFound />} />
            </Routes>
        </>
    );
}

export default function AppWrapper() {
    return (
        <Router>
            <App />
        </Router>
    );
}
